import { type ComponentPropsWithRef } from "react";
import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "./InputLabelTop.styled";
import { Typography } from "../Typography";
import {
  InputLabelTopTooltip,
  type InputLabelTopTooltipProps,
} from "../InputLabelTopTooltip";

type TooltipProps = Omit<InputLabelTopTooltipProps, "otherIconButtonProps">;

export type InputLabelTopProps = Omit<
  ComponentPropsWithRef<"label">,
  "htmlFor" | "style" | "className"
> & {
  htmlFor: string;
  label?: string;
  labelTooltipProps?: TooltipProps;
  labelHint?: string;
  labelHintID?: string;
  labelHintTooltipProps?: TooltipProps;
};

function InputLabelTop(props: InputLabelTopProps) {
  const {
    label,
    labelTooltipProps,
    labelHint,
    labelHintID,
    labelHintTooltipProps,
    children,
    ...labelProps
  } = props;

  const { tokens } = useDesignTokens();
  const { inputLabelTop } = tokens;

  return (
    <S.Container $label={label}>
      <div>
        <div>
          <label {...labelProps}>
            {label && (
              <Typography
                component="span"
                color={inputLabelTop.label.color}
                variant={inputLabelTop.label.typography.variant}
                fontFamily={inputLabelTop.label.typography.fontFamily}
              >
                {label}
              </Typography>
            )}
          </label>

          {labelTooltipProps && (
            <InputLabelTopTooltip
              {...labelTooltipProps}
              otherIconButtonProps={{
                variant: "default",
                typographyVariant: inputLabelTop.label.typography.variant,
              }}
            />
          )}
        </div>

        {labelHint && (
          <Typography
            id={labelHintID}
            component="div"
            color={inputLabelTop.labelHint.color}
            variant={inputLabelTop.labelHint.typography.variant}
            fontFamily={inputLabelTop.labelHint.typography.fontFamily}
          >
            {labelHint}

            {labelHintTooltipProps && (
              <InputLabelTopTooltip
                {...labelHintTooltipProps}
                otherIconButtonProps={{
                  variant: "default20",
                  typographyVariant: inputLabelTop.labelHint.typography.variant,
                }}
              />
            )}
          </Typography>
        )}
      </div>

      <div>{children}</div>
    </S.Container>
  );
}

export default InputLabelTop;
